import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"; // ✅ Importer React Query
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// src/index.js (ou là où tu as mis l’interceptor)
import axios from "axios";
// src/index.js
import 'leaflet/dist/leaflet.css';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.error_code;
    const url = error.config?.url || "";

    // 1) On ignore certains endpoints sensibles (login, upload avatar)
    if (url.includes("/auth/login.php")) {
      return Promise.reject(error);
    }

    // Ici, pour debug, on peut aussi ignorer upload_avatar si tu veux
    // pour éviter la déconnexion généralisée :
    // if (url.includes("/users/upload_avatar.php")) {
    //   return Promise.reject(error);
    // }

    if (status === 401 || status === 403) {
      // cas vraiment liés au compte
      if (code === "account_disabled") {
        alert(
          "Votre compte a été désactivé. Veuillez contacter l’administrateur."
        );
      } else if (code === "account_deleted") {
        alert(
          "Votre compte a été supprimé. Veuillez contacter l’administrateur."
        );
      } else if (
        code === "missing_token" ||
        code === "invalid_token" ||
        code === "token_expired"
      ) {
        // ➜ cas authentification
        alert("Votre session a expiré ou n’est plus valide.");
      } else {
        // 401 pour une autre raison (ex: validation, erreur d’upload) →
        // on laisse la page locale gérer normalement dans le catch()
        return Promise.reject(error);
      }

      // 🔐 Ici seulement on fait la déconnexion complète
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      delete axios.defaults.headers.common["Authorization"];

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    {" "}
    {/* ✅ Fournir le client à l'application */}
    <App />,
  </QueryClientProvider>
);
